import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getBudgetQuotationDataApi, getEquipmentPlanListDataApi, getEquipmentTransferListDataApi, getMaterialPlanListDataApi, getPersonnelPlanApi, getProjectPlanLandNodeApi, postBudgetQuotationDataApi, postEquipmentPlanDataApi, postEquipmentTransferDataApi, postMaterialPlanDataApi, postMobilisationPlanDataApi, postPersonnelPlanDataApi, postProjectPlanLandNodeApi } from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    pmDictData: null, // 字典
    materialData: null, // 材料计划
    BudgetQuotationData: null, // 预算
    EquipmentData: null, // 设备
    EquipmentTransferData: null, // 设备调拨
    ProjectPlanLandNodeData: null, // 生产计划
    PersonnelPlanData: null // 人员计划
}

/* ======================================动迁计划接口 ===================================================== */

/* 提交 动迁计划 数据 */
export const postMobilisationPlanAction = createAsyncThunk(
    'PlanSlice/postMobilisationPlanAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await postMobilisationPlanDataApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* ====================================== 材料计划接口 ===================================================== */

/* 查询表格数据 */
export const getMaterialPlanListDataAction = createAsyncThunk(
    'PlanSlice/getMaterialPlanListDataAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getMaterialPlanListDataApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 提交 材料计划 数据 */
export const postMaterialPlanAction = createAsyncThunk(
    'PlanSlice/postMaterialPlanAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await postMaterialPlanDataApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* ====================================== 设备调拨接口 ===================================================== */

/* 查询表格数据 */
export const getEquipmentTransferListDataAction = createAsyncThunk(
    'PlanSlice/getEquipmentTransferListDataAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getEquipmentTransferListDataApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 提交 设备调拨 数据 */
export const postEquipmentTransferAction = createAsyncThunk(
    'PlanSlice/postEquipmentTransferAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await postEquipmentTransferDataApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)


/* ====================================== 人员计划接口 ===================================================== */

/* 查询表格数据 */
export const getPersonnelPlanListDataAction = createAsyncThunk(
    'PlanSlice/getPersonnelPlanListDataAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getPersonnelPlanApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 提交 材料计划 数据 */
export const postPersonnelPlanAction = createAsyncThunk(
    'PlanSlice/postPersonnelPlanAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await postPersonnelPlanDataApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* ====================================== 生产计划接口 ===================================================== */

/* 查询表格数据 */
export const getProjectPlanLandNodeAction = createAsyncThunk(
    'PlanSlice/getProjectPlanLandNodeAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getProjectPlanLandNodeApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 提交 生产计划 数据 */
export const postProjectPlanLandNodeAction = createAsyncThunk(
    'PlanSlice/postProjectPlanLandNodeAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await postProjectPlanLandNodeApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* ====================================== 设备计划接口 ===================================================== */

/* 查询表格数据 */
export const getEquipmentPlanListDataAction = createAsyncThunk(
    'PlanSlice/getEquipmentPlanListDataAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getEquipmentPlanListDataApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 提交 projectBase 数据 */
export const postEquipmentPlanAction = createAsyncThunk(
    'PlanSlice/postEquipmentPlanAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await postEquipmentPlanDataApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* ====================================== 预算接口 ===================================================== */

/* 查询表格数据 */
export const getBudgetQuotationDataAction = createAsyncThunk(
    'PlanSlice/getBudgetQuotationDataAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getBudgetQuotationDataApi(params)
            return data?.data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 提交 预算 数据 */
export const postBudgetQuotationDataAction = createAsyncThunk(
    'PlanSlice/postBudgetQuotationDataAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await postBudgetQuotationDataApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

export const PlanSlice = createSlice({
    name: 'PlanSlice',
    initialState,
    reducers: {
    },
    extraReducers: {
        /* 获取 MaterialPlan 数据 */
        [getMaterialPlanListDataAction.fulfilled.type]: (state, action) => {
            state.materialData = action.payload
        },
        /* 获取 设备调拨 数据 */
        [getEquipmentTransferListDataAction.fulfilled.type]: (state, action) => {
            state.EquipmentTransferData = action.payload
        },
        /* 获取 BudgetQuotation 数据 */
        [getBudgetQuotationDataAction.fulfilled.type]: (state, action) => {
            state.BudgetQuotationData = action.payload
        },
        /* 获取 EquipmentPlan 数据 */
        [getEquipmentPlanListDataAction.fulfilled.type]: (state, action) => {
            state.EquipmentData = action.payload
        },
        /* 获取 ProjectPlanLandNodeData 数据 */
        [getProjectPlanLandNodeAction.fulfilled.type]: (state, action) => {
            state.ProjectPlanLandNodeData = action.payload
        },
        /* 获取 ProjectPlanLandNodeData 数据 */
        [getPersonnelPlanListDataAction.fulfilled.type]: (state, action) => {
            state.PersonnelPlanData = action.payload
        },
    },
})
